


































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import LocationProfileDto from '@/models/Locations/LocationProfileDto';
import CreateBookingRequest from '@/models/Bookings/CreateBookingRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import JobDto from '@/models/Jobs/JobDto';
import { LocationListModule } from '@/store/modules/locationList';
import { JobListModule } from '@/store/modules/jobList';
import PageNames from '@/router/PageNames';
import CreateJobRequest from '@/models/Jobs/CreateJobRequest';
import ContactLocationDto from '@/models/ContactLocations/ContactLocationDto';
import ajax from '@/lib/ajax';
import { AppModule } from '@/store/modules/app';
import PositionDto from '@/models/Positions/PositionDto';
import JobType from '@/models/Jobs/JobType';

@Component({
    name: 'JobCreate'
})
export default class JobCreate extends GiganautVueDialog {
 
  entity: JobDto = new JobDto();
  closingDateAsString = '';
  desiredStartDateAsString = '';
  contactLocations: ContactLocationDto[] = [];
  selectedContactLocation: ContactLocationDto = new ContactLocationDto();

  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = new JobDto();
      this.entity.headcount = 1;
      if (LocationListModule.locations.length === 0) {
        LocationListModule.searchLocations();
      }
      if (AgencySettingsModule.agencyUsers.length === 0) {
        AgencySettingsModule.getAgencyUsers();
      }
      if (AgencySettingsModule.branches) {
        await AgencySettingsModule.getBranches();
      }
      if (AgencySettingsModule.positions) {
        await AgencySettingsModule.getPositions();
      }
      if (AgencySettingsModule.skills) {
        await AgencySettingsModule.getSkills();
      }
      if (AgencySettingsModule.qualifications) {
        await AgencySettingsModule.getQualifications();
      }
    }
  }

  @Watch("entity.location")
  async onLocationChanged(newVal: LocationProfileDto, oldVal: LocationProfileDto) {
    if (newVal.id) { 
      //We get this direct as introducing the store would be pointless - it's throw away data
      await ajax.get(`/api/v1/agency/locations/${newVal.id}/contacts`)
      .then(response => {
        this.contactLocations = response.data;
      })
      .catch(error => {
        AppModule.handleApiError(error);

      })
    }
  }

  @Watch("entity.primaryPosition")
  async onPrimaryPositionChanged(newVal: PositionDto, oldVal: PositionDto) {
    this.entity.title = newVal.name;
  }

  get selectedContact() {
    return this.selectedContactLocation;
  }

  set selectedContact(contactLocation: ContactLocationDto) {
    this.selectedContactLocation = contactLocation;
    this.entity.contact = contactLocation.contact;
    this.entity.contactId = contactLocation.contactId;
  }

  get departments() {
    return this.entity.location.departments;
  }

  get locations() {
    return LocationListModule.locations;
  }

  get branches() {
    return AgencySettingsModule.branches;
  }

  get desks() {
    return this.entity.branch.desks;
  }

  get positions() {
    return AgencySettingsModule.positions;
  }

  get skills() {
    return AgencySettingsModule.skills;
  }

  get qualifications() {
    return AgencySettingsModule.qualifications;
  }

  get agencyUsers() {
    return AgencySettingsModule.agencyUsers;
  }

  get loading() {
    return JobListModule.loadingDialog;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    
    const request = new CreateJobRequest()
    request.branchId = this.entity.branch.id;
    request.companyId = this.entity.location.companyId;
    request.locationId = this.entity.location.id;
    request.contactId = this.entity.contact.id;
    request.deskId = this.entity.desk.id
    request.departmentId = this.entity.department.id;
    request.ownerId = this.entity.owner.id;
    request.headcount = Number(this.entity.headcount);
    request.type = JobType.Permanent;
    request.closingDate = this.closingDateAsString;
    request.desiredStartDate = this.desiredStartDateAsString;
    request.primaryPositionId = this.entity.primaryPosition.id;
    request.annualSalaryMin = this.entity.annualSalaryMin;
    request.annualSalaryMax = this.entity.annualSalaryMax;
    request.title = this.entity.title;
    request.secondaryPositionIds = [];
    if (this.entity.secondaryPositions.length > 0) {
      for (let index = 0; index < this.entity.secondaryPositions.length; index++) {
        const position = this.entity.secondaryPositions[index];
        request.secondaryPositionIds.push(position.id);
      }
    }
    if (this.entity.primarySkills.length > 0) {
      for (let index = 0; index < this.entity.primarySkills.length; index++) {
        const skill = this.entity.primarySkills[index];
        request.primarySkillIds.push(skill.id);
      }
    }
    if (this.entity.secondarySkills.length > 0) {
      for (let index = 0; index < this.entity.secondarySkills.length; index++) {
        const skill = this.entity.secondarySkills[index];
        request.secondarySkillIds.push(skill.id);
      }
    }
    if (this.entity.primaryQualifications.length > 0) {
      for (let index = 0; index < this.entity.primaryQualifications.length; index++) {
        const qual = this.entity.primaryQualifications[index];
        request.primaryQualificationIds.push(qual.id);
      }
    }
    if (this.entity.secondaryQualifications.length > 0) {
      for (let index = 0; index < this.entity.secondaryQualifications.length; index++) {
        const qual = this.entity.secondaryQualifications[index];
        request.secondaryQualificationIds.push(qual.id);
      }
    }
    request.isTest = this.entity.isTest;
    if (request.isTest) {
      request.testEmailAddresses = this.entity.testEmailAddresses;
    }
   
    await JobListModule.createJob(request)
    if (JobListModule.newJobId !== '') {
      this.$router.push({ name: PageNames.AgencyJobDetails, params: { jobid: JobListModule.newJobId } });
    }
    this.dialog = false;
  }
}
